// @flow
import dispatchAsync from 'utils/dispatchAsync';
import type { ZuzuThunk } from 'types';

export type Answer = {
  answerId: string,
  text: string,
};
export type Vote = {
  selectedAnswerId: string,
  communityId: string,
};
export type SurveyType = 'closed' | 'open';
export type Survey = {
  surveyId: string,
  title: string,
  description: string,
  createdAt: number,
  endsAt: number,
  visibleIn: { [communityId: string]: string },
  createdBy: string,
  answers: Array<Answer>,
  votes: Array<Vote>,
  image: ?string,
  type: SurveyType,
};
export type LoadSurveysAction = {
  type: 'LOAD_SURVEYS',
  payload?: Array<Survey>,
  meta: {
    done: boolean,
    error?: boolean,
  },
};
export const LOAD_SURVEYS = 'LOAD_SURVEYS';
export const loadSurveys = (): ZuzuThunk => async dispatch => {
  return dispatchAsync({
    type: LOAD_SURVEYS,
    url: '/api/management/survey/all',
    method: 'get',
    dispatch,
    transform: payload => [
      ...payload.sort((a, b) => b.createdAt - a.createdAt),
    ],
  });
};

export const CREATE_SURVEY = 'CREATE_SURVEY';
export const createSurvey = (
  title: string,
  description: string,
  answers: Array<string>,
  endsAt: number,
  visibleIn: Array<string>,
  image: string,
  type: SurveyType
): ZuzuThunk => async dispatch => {
  return dispatchAsync({
    type: CREATE_SURVEY,
    url: '/api/management/survey',
    method: 'post',
    dispatch,
    body: {
      title,
      description,
      answers,
      endsAt,
      visibleIn,
      image,
      type,
    },
  });
};

export const DELETE_SURVEY = 'DELETE_SURVEY';
export const deleteSurvey = (
  surveyId: string,
  reason: string
): ZuzuThunk => async dispatch =>
  dispatchAsync({
    type: DELETE_SURVEY,
    url: '/api/management/survey/delete',
    method: 'post',
    dispatch,
    body: {
      surveyId,
      reason,
    },
  });

export const EDIT_SURVEY = 'EDIT_SURVEY';
export const editSurvey = (
  surveyId: string,
  field: string,
  value: string | number
): ZuzuThunk => async dispatch =>
  dispatchAsync({
    type: EDIT_SURVEY,
    url: '/api/management/survey',
    method: 'put',
    body: {
      surveyId,
      field,
      value,
    },
    dispatch,
  });



// WEBPACK FOOTER //
// ./src/redux/actions/surveys.js